module.exports = __webpack_public_path__ + "static/media/icon-yt-blue.148e6707.svg";